import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import BrandLogo from "../../atoms/BrandLogo/BrandLogo";
import NavItem from "../../molecules/NavItem/NavItem";

import "./Footer.css";
const Footer = ({routes}) => {
    return (
        <footer className="pt-5  pb-3 mt-auto ccl-bg-blue">
            <Container>
                {/* Large screen: 4 columns */}
                <Row>
                    <Col lg={3} md={6} sm={12} className="mb-4 d-flex justify-content-center">
                        <BrandLogo color="white" />
                    </Col>
                    <Col lg={3} md={6} sm={12} className="mb-5 text-white">
                        <h5 className="text-center text-md-start">
                            Navigation
                        </h5>
                        <hr className="ccl-d-blue mx-xs-5" />
                        {Object.entries(routes).map(([path, text]) => (
                            <NavItem
                                key={path}
                                to={path}
                                className="text-center text-md-start"
                            >
                                {text}
                            </NavItem>
                        ))}
                        <NavItem to="/login" className="text-center text-md-start">Admin Login</NavItem>
                    </Col>
                    <Col lg={3} md={6} sm={12} className="mb-5 text-white">
                        <h5 className="text-center text-md-start">
                            Contact Us
                        </h5>
                        <hr className="ccl-d-blue mx-xs-5" />

                        <p className="text-center text-md-start">
                            <a
                                href="mailto:support@churchcamlive.ie"
                                className="text-decoration-none text-white"
                            >
                                Support@ChurchCamLive.ie
                            </a>
                        </p>
                        <p class="text-center text-md-start">
                            <small>
                                Loughlahan, Thurles, Co Tipperary E41 T282
                            </small>
                        </p>
                    </Col>
                    <Col lg={3} md={6} sm={12} className="mb-5 text-white">
                        <h5 className="text-center text-md-start">
                            Get Connected
                        </h5>
                        <hr className="ccl-d-blue mx-xs-5" />
                        <div className="d-flex justify-content-center justify-content-md-start">
                            <i class="bx bxl-facebook-circle fs-1"></i>
                            <i class="bx bxl-twitter fs-1"></i>
                            <i class="bx bxl-linkedin-square fs-1"></i>
                        </div>
                    </Col>
                    <Col lg={12} className="my-1 text-center text-white">
                        © Copyright ChurchCamLive.ie {new Date().getFullYear()}
                    </Col>
                </Row>
            </Container>
        </footer>
    );
};

export default Footer;
